module.exports = __webpack_public_path__ + "img/blastness.83268d09.jpg";